<template>
  <section id="main" class="app-main">
    <div class="page-content">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="key"/>
      </keep-alive>
      <transition mode="out-in" name="fade-transform">
        <router-view v-if="!$route.meta.keepAlive" :key="key"/>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  min-height: calc(100vh - 56px);
  width: 100%;
  position: relative;
  overflow: auto;
}

.page-content {
  min-height: inherit;
}

.fixed-header + .app-main {
  padding-top: 56px;
}

@media only screen and (max-width: 767px) {
  .app-main {
    padding: 0 !important;
  }
}

.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
